// src/utils/reportCaughtError.ts
var CAUGHT_ERROR_EVENT = "mt:caught-error";
function reportCaughtError(detail) {
  try {
    if (typeof window === "undefined") return;
    window.dispatchEvent(
      new CustomEvent(CAUGHT_ERROR_EVENT, { detail })
    );
  } catch {
  }
}

export {
  CAUGHT_ERROR_EVENT,
  reportCaughtError
};
//# sourceMappingURL=chunk-ETY2OVGU.mjs.map